import { Moto, Depoimento, Entrega } from '../types';

export const motosMock: Moto[] = [
  {
    id: '1',
    nome: 'Honda CG 160 Start',
    modelo: 'CG 160',
    ano: 2024,
    cilindrada: 162.7,
    consumo: '41 km/l',
    tanque: '13.5 litros',
    peso: '135 kg',
    preco: 13490,
    precoPromocional: 12990,
    estoque: 5,
    categoria: 'Street',
    descricao: 'A moto mais vendida do Brasil, agora com design renovado e tecnologia de ponta.',
    imagens: [
      'https://trae-api-us.mchost.guru/api/ide/v1/text_to_image?prompt=Honda%20CG%20160%20Start%202024%20vermelha%20em%20est%C3%BAdio%20fotogr%C3%A1fico%2C%20alta%20qualidade%2C%20foco%20nos%20detalhes&image_size=square_hd',
      'https://trae-api-us.mchost.guru/api/ide/v1/text_to_image?prompt=Honda%20CG%20160%20Start%202024%20preta%20lateral%2C%20fotografia%20profissional&image_size=square',
    ],
    destaque: true,
    visualizacoes: 1250,
    createdAt: '2024-01-15',
    updatedAt: '2024-01-15',
  },
  {
    id: '2',
    nome: 'Honda Pop 110i',
    modelo: 'Pop 110i',
    ano: 2024,
    cilindrada: 109.1,
    consumo: '48 km/l',
    tanque: '12.5 litros',
    peso: '108 kg',
    preco: 8990,
    precoPromocional: 8590,
    estoque: 3,
    categoria: 'Economia',
    descricao: 'A escolha perfeita para quem busca economia e confiabilidade no dia a dia.',
    imagens: [
      'https://trae-api-us.mchost.guru/api/ide/v1/text_to_image?prompt=Honda%20Pop%20110i%202024%20azul%20fotografia%20profissional%2C%20est%C3%BAdio%20branco&image_size=square_hd',
    ],
    destaque: false,
    visualizacoes: 890,
    createdAt: '2024-01-16',
    updatedAt: '2024-01-16',
  },
  {
    id: '3',
    nome: 'Honda Elite 125',
    modelo: 'Elite 125',
    ano: 2024,
    cilindrada: 124.6,
    consumo: '45 km/l',
    tanque: '14.5 litros',
    peso: '128 kg',
    preco: 7890,
    precoPromocional: 7490,
    estoque: 8,
    categoria: 'Scooter',
    descricao: 'Scooter moderna e ágil, ideal para o trânsito urbano com estilo e conforto.',
    imagens: [
      'https://trae-api-us.mchost.guru/api/ide/v1/text_to_image?prompt=Honda%20Elite%20125%202024%20branca%20scooter%2C%20fotografia%20moderna%2C%20%C3%A2ngulos%20din%C3%A2micos&image_size=square_hd',
    ],
    destaque: true,
    visualizacoes: 1100,
    createdAt: '2024-01-17',
    updatedAt: '2024-01-17',
  },
  {
    id: '4',
    nome: 'Honda Biz 110i',
    modelo: 'Biz 110i',
    ano: 2024,
    cilindrada: 109.1,
    consumo: '46 km/l',
    tanque: '13 litros',
    peso: '110 kg',
    preco: 8490,
    estoque: 2,
    categoria: 'Scooter',
    descricao: 'A scooter mais versátil do mercado, com espaço para bagagem e conforto superior.',
    imagens: [
      'https://trae-api-us.mchost.guru/api/ide/v1/text_to_image?prompt=Honda%20Biz%20110i%202024%20vermelha%20scooter%2C%20fotografia%20detalhada&image_size=square_hd',
    ],
    destaque: false,
    visualizacoes: 950,
    createdAt: '2024-01-18',
    updatedAt: '2024-01-18',
  },
];

export const depoimentosMock: Depoimento[] = [
  {
    id: '1',
    nome: 'Carlos Silva',
    avaliacao: 5,
    comentario: 'Excelente atendimento! Comprei minha CG 160 e estou muito satisfeito. A entrega foi rápida e o pós-venda é ótimo.',
    moto: 'Honda CG 160 Start',
    data: '2024-01-10',
    aprovado: true,
  },
  {
    id: '2',
    nome: 'Maria Santos',
    avaliacao: 4,
    comentario: 'Adorei minha Pop 110i! Economia excelente e muito confortável para o dia a dia. Recomendo!',
    moto: 'Honda Pop 110i',
    data: '2024-01-08',
    aprovado: true,
  },
  {
    id: '3',
    nome: 'João Oliveira',
    avaliacao: 5,
    comentario: 'A Elite 125 é perfeita para a cidade! Muito ágil e econômica. O atendimento da loja foi impecável.',
    moto: 'Honda Elite 125',
    data: '2024-01-05',
    aprovado: true,
  },
];

export const entregasMock: Entrega[] = [
  {
    id: '1',
    imagem: 'https://trae-api-us.mchost.guru/api/ide/v1/text_to_image?prompt=Cliente%20feliz%20recebendo%20moto%20Honda%20CG%20160%20vermelha%2C%20foto%20de%20entrega%2C%20sorrindo%2C%20loja%20de%20motos%20fundo&image_size=landscape_4_3',
    titulo: 'Entrega CG 160 - Carlos',
    descricao: 'Mais uma entrega realizada com sucesso!',
    ordem: 1,
    ativa: true,
    data: '2024-01-15',
  },
  {
    id: '2',
    imagem: 'https://trae-api-us.mchost.guru/api/ide/v1/text_to_image?prompt=Cliente%20recebendo%20moto%20Honda%20Pop%20110i%20azul%2C%20foto%20de%20entrega%2C%20ambiente%20de%20loja&image_size=landscape_4_3',
    titulo: 'Entrega Pop 110i - Ana',
    descricao: 'Cliente muito feliz com sua nova moto!',
    ordem: 2,
    ativa: true,
    data: '2024-01-14',
  },
];